module.exports = __webpack_public_path__ + "img/contact-img-logo.aeac9b45.png";